import React from 'react';
import withAuth from './with-auth';

export function LoggedIn({children, inverse = false, isLoggedIn = false}) {
    if (
        (inverse && !isLoggedIn)
        || (!inverse && isLoggedIn)
    ) {
        return (
            <React.Fragment>
                {children}
            </React.Fragment>
        );
    }
    return null;
}

export default withAuth(LoggedIn);


// WEBPACK FOOTER //
// ./src/universal/components/auth/logged-in.js